function MountainWithFlagIcon({
  size = 36,
  className = '',
  variant = 'default',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  variant?: 'default' | 'larger';
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      {variant === 'larger' ? (
        <svg
          className='inline-block'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='currentColor'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12.0416 2.2847C12.2855 2.12842 12.5922 2.10712 12.8553 2.22817L18.3664 4.76313C18.668 4.90184 18.8612 5.20341 18.8612 5.53535C18.8612 5.86729 18.668 6.16886 18.3664 6.30758L13.3501 8.61494V9.60784L23.6418 21.4426C23.8604 21.6939 23.912 22.0497 23.7739 22.3528C23.6358 22.6559 23.3335 22.8504 23.0004 22.8504H2.0004C1.66735 22.8504 1.36499 22.6559 1.2269 22.3528C1.08882 22.0497 1.14046 21.6939 1.359 21.4426L11.6501 9.60844V3.00039C11.6501 2.71072 11.7977 2.44098 12.0416 2.2847ZM13.3501 4.32698V6.74372L15.9772 5.53535L13.3501 4.32698ZM12.5004 11.2214L10.425 13.608L12.4817 15.0996L14.5027 13.5239L12.5004 11.2214ZM15.6198 14.8085L13.0228 16.8334C12.7242 17.0662 12.3076 17.0734 12.0011 16.8511L9.30508 14.8958L3.86601 21.1504H21.1348L15.6198 14.8085Z'
          />
        </svg>
      ) : (
        <svg
          className='inline-block'
          width={size}
          height={size}
          viewBox='0 0 38 38'
          fill='currentColor'
        >
          <path d='M17.9105 2.92642C17.6258 2.79563 17.2939 2.81846 17.0299 2.987C16.7659 3.15553 16.6062 3.44655 16.6062 3.7591V13.1084L2.11971 29.7455C1.8836 30.0166 1.828 30.4003 1.97746 30.727C2.12691 31.0537 2.4539 31.2633 2.81405 31.2633H32.2382C32.5983 31.2633 32.9253 31.0537 33.0748 30.727C33.2242 30.4003 33.1686 30.0166 32.9325 29.7455L18.4452 13.1075V11.4407L25.6323 8.13904C25.9583 7.98931 26.1671 7.66418 26.1671 7.30636C26.1671 6.94854 25.9583 6.62341 25.6323 6.47368L17.9105 2.92642ZM23.0502 7.30636L18.4452 9.42179V5.19093L23.0502 7.30636ZM14.2175 18.6487L17.5261 14.8489L20.7255 18.5233L17.5057 21.0304L14.2175 18.6487ZM18.0917 22.9006L21.9328 19.9097L30.2222 29.4297H4.83004L13.0073 20.0385L16.9853 22.9198C17.3171 23.1602 17.7685 23.1523 18.0917 22.9006Z' />
        </svg>
      )}
    </span>
  );
}

export default MountainWithFlagIcon;
